/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { WalletconnectModule } from "@vlinder-web/walletconnect-module-react";
//import { WalletconnectModule } from '../modules/WalletConnect';
import {LANDING_NAV, INNER_PAGES_NAV} from "./test-data/header.nav";

const MODULE_NAME = "HeaderNavService";
const log: any = LoggerModule.getInstance();

const getWalletModule = () => {
    const vapp = VApplication.getInstance();
    const walletconnentModule = vapp.getSync(
        "services.WalletconnectModule"
    ) as WalletconnectModule;
    return walletconnentModule;
};

const getLoginService = () => {
    const loginService = VApplication.getInstance().getSync(
        "services.AuthService"
    ) as AuthService;

    if(loginService.isAuthenticated()){
        return true
    }
    else return false;
}

interface IProps {
    categories?:any,
    mintpadURL?:any;
 }


export class HeaderNavService {
    private static instance: HeaderNavService;
    private vapp: VApplication;
    private categories;
    private mintpadURL;
    private faqURL;
    private constructor(props: IProps | any) {
        this.vapp = VApplication.getInstance();
        this.categories = props.categories;
        this.mintpadURL = props.mintpadURL;
        this.faqURL = props.faqURL;
    }
    public static getInstance(props: any = {}): HeaderNavService {
        if (!HeaderNavService.instance) {
            HeaderNavService.instance = new HeaderNavService(props);
        }
        return HeaderNavService.instance;
    }

    // async getNavItems() {
    //         return LANDING_NAV
    // }

    _getItems(items:any){
        let _navItems = items?.map((key:any)=>{
            if(key?.eventKey === "sports"){
                return({
                    ...key,
                    link:"/collection/sports"
                })
            }
            else if (key?.eventKey === "collectibles"){
                return({
                    ...key,
                    link: "/collection/collectibles"
                })
            }
            else if(key?.eventKey === "entertainment"){
                return({
                    ...key,
                    link:"/collection/entertainment"
                })
            }
            else return({
                ...key
            })
        })
        return _navItems;
    }

    async getInnerNavItems(){
        const getCategories = HeaderNavService.getInstance();
            let _innerNav = LANDING_NAV.map(item=>{
                if(item?.id === "categories"){
                    return({
                        ...item,
                        items: getCategories?.categories
                    })
                }
                // else if(item?.id === "mintpad"){
                //     return({
                //         ...item,
                //         link: getCategories?.mintpadURL
                //     })
                // }
                else return({
                    ...item
                })
            })
        return _innerNav.filter(item=> item?.id !=="more");
    }

    _getMoreItems(items:any){
        const getCategories = HeaderNavService.getInstance();
        const _menu = items && Array.isArray(items) && items.map((item:any)=>{
            if(item.id === "faq"){
                return(
                    {
                        ...item,
                        link:getCategories?.faqURL
                    }
                )
            }
            if(item.id === "mintpad"){
                return(
                    {
                        ...item,
                        link:getCategories?.mintpadURL ?  `${getCategories?.mintpadURL}login` : "#"
                    }
                )
            }
            else{
                return({
                    ...item
                });
            }
            
        })
        return _menu;
    }

    async getNavItems() {
        const getCategories = HeaderNavService.getInstance();
            let _innerNav = LANDING_NAV.map(item=>{
                if(item?.id === "categories"){
                    return({
                        ...item,
                        items: getCategories?.categories
                    })
                }
                if(item?.id === "more"){
                    return({
                        ...item,
                        items:this._getMoreItems(item?.items)
                    }) 
                }
                // else if(item?.id === "mintpad"){
                //     return({
                //         ...item,
                //         link: getCategories?.mintpadURL
                //     })
                // }
                else return({
                    ...item
                })
            })
        return _innerNav;
    }
}